export default __webpack_public_path__ + "static/media/Skey-Network-Cube-Small.9d0c6c5b.png";